import React from 'react';
import {
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  useMediaQuery,
} from '@mui/material';
import {
  OutlinedIcons,
} from '@marageti/z4-lib';
import { BucketCounts, ListName } from './my-queue-utils';

const {
  OutlinedRefreshIcon,
  OutlinedInboxInIcon,
  OutlinedExclamationIcon,
  OutlinedCalendarIcon,
  OutlinedEyeIcon,
  OutlinedBellIcon,
} = OutlinedIcons;

const icons: { [key: string]: any } = {
  'Traveler Inbox': <OutlinedInboxInIcon />,
  'Partner Inbox': <OutlinedInboxInIcon />,
  'In Progress': <OutlinedRefreshIcon />,
  'Match Declined': <OutlinedExclamationIcon />,
  Postponed: <OutlinedCalendarIcon />,
  Following: <OutlinedEyeIcon />,
  Reminders: <OutlinedBellIcon />,
};

type SideBarProps = {
  onChange: (name: ListName) => void;
  selectedItem: string;
  bucketCounts: BucketCounts | undefined;
};

type SideBarItemProps = {
  name: ListName;
  onChange: (name: ListName) => void;
  selected: string;
  totalHits: number | undefined;
};

const SideBarItem = ({
  name,
  onChange,
  selected,
  totalHits,
}: SideBarItemProps) => (
  <ListItem disablePadding>
    <ListItemButton
      disabled={selected === name}
      onClick={() => onChange(name)}
      style={{ padding: '12px 0' }}
    >
      <ListItemIcon style={{ minWidth: '40px' }}>
        {icons[name]}
      </ListItemIcon>
      <ListItemText primary={`${name}${totalHits === undefined ? '' : ` (${totalHits})`}`} style={{ margin: 0 }} />
    </ListItemButton>
  </ListItem>
);

const SideBar = ({
  bucketCounts,
  onChange,
  selectedItem,
}: SideBarProps) => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('desktop'));

  const handleDropdownChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as ListName);
  };

  if (isMobile) {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel id="category-select-label">Category</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          value={selectedItem}
          onChange={handleDropdownChange}
          label="Category"
        >
          {Object.keys(icons).map((name) => {
            const key = name as ListName;
            return (
              <MenuItem key={name} value={name}>
                {`${name}${bucketCounts && bucketCounts[key] !== undefined ? ` (${bucketCounts[key]})` : ''}`}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }

  return (
    <List>
      <SideBarItem name="Traveler Inbox" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.['Traveler Inbox']} />
      <SideBarItem name="Partner Inbox" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.['Partner Inbox']} />
      <Divider style={{ margin: '12px 0' }} />
      <SideBarItem name="In Progress" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.['In Progress']} />
      <SideBarItem name="Match Declined" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.['Match Declined']} />
      <SideBarItem name="Postponed" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.Postponed} />
      <SideBarItem name="Following" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.Following} />
      <Divider style={{ margin: '12px 0' }} />
      <SideBarItem name="Reminders" onChange={onChange} selected={selectedItem} totalHits={bucketCounts?.Reminders} />
    </List>
  );
};

export default SideBar;
